export default __webpack_public_path__ + "static/media/zgram.f673097b.png";